import { useDesignSystem } from 'contexts/design-system'
import PageTitleEui from './pageTitle.eui'
import PageTitleMui from './pageTitle.mui'
import { PageTitleProps } from './types'

export type { PageTitleProps } from './types'

export default function PageTitle( props: PageTitleProps ) {
	return useDesignSystem() === 'mui'
		? <PageTitleMui {...props} />
		: <PageTitleEui {...props} />
}
